import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PreCheckoutViagemService {

  value = new BehaviorSubject<Values>(new Values());
  constructor() { }

  public setValue(value: Values): void {
    this.value.next(value);
  }

  public getValues(): Observable<Values> {
    return this.value.asObservable();
  }
}

export class Values{
  constructor(
    cdOrigem: number = 0,
    rota: string = null
  ){

    this.cdOrigem = cdOrigem;
    this.rota = rota;
  }

  cdOrigem: number;
  rota: string;
}